module.exports = __webpack_public_path__ + "static/media/cases.8b9d377f.png";